import { create } from "zustand";

interface PipelineState {
  runId: number | null;
  label: string | null;
  setRun: (runId: number | null, label?: string | null) => void;
  clearRun: () => void;
}

export const usePipeline = create<PipelineState>((set) => ({
  runId: null,
  label: null,
  setRun: (runId, label = null) => set({ runId, label }),
  clearRun: () => set({ runId: null, label: null }),
}));